export default __webpack_public_path__ + "static/media/send-icon-blue.3cc30c54.svg";